import PortalIdParser from 'PortalIdParser';
import { ApiMap } from '../ApiMap';
import { createApiCache, MAX_CACHE_TIMEOUT } from './createApiCache';
import { HubUserAttributesClient } from 'frontend-preferences-client';
const UserCache = {};
export function getFetchUsers(http) {
  const withUserCache = createApiCache(http.get, ApiMap.USERS.getUrl, UserCache, MAX_CACHE_TIMEOUT);
  const hubId = PortalIdParser.get();
  return function fetchUsers() {
    const httpParams = {
      query: {
        hubId
      }
    };
    return withUserCache('', httpParams);
  };
}
const PortalCurrencyCache = {};
export function getPortalCurrency(http) {
  const withPortalCurrencyCache = createApiCache(http.get, ApiMap.PORTAL_CURRENCY.getUrl, PortalCurrencyCache, MAX_CACHE_TIMEOUT);
  return function getCurrency() {
    return withPortalCurrencyCache();
  };
}
const hubUserAttributesClient = HubUserAttributesClient.forCaller('hubspot-tinymce');
export function getUserAttributes() {
  const defaultValue = '';
  return async function fetchAttributes(key) {
    return await hubUserAttributesClient.fetch(key, defaultValue);
  };
}
export function setUserAttribute() {
  return function setAttribute(attribute, value) {
    return hubUserAttributesClient.write(attribute, value);
  };
}